import { Form } from 'factorial-form'

import PermissionAccessGroup from 'modules/permissions/store/models/PermissionAccessGroup'

export class VisibilityForm extends Form {
  constructor(values = {}) {
    super(values, {
      strategy: 'string',
      groupable_type: 'string',
      groupable_id: 'number',
      query_id: 'string',
      team_ids: 'any',
      location_ids: 'any',
      legal_entity_ids: 'any',
    })
  }

  get isFql(): boolean {
    return this.get('strategy').value === PermissionAccessGroup.Strategies.fql
  }

  get isFqlMultiselect(): boolean {
    return this.get('strategy').value === PermissionAccessGroup.Strategies.fqlMultiselect
  }
}
